import Papa from 'papaparse';

/**
 * Exports data to CSV/Excel format and triggers download
 * 
 * @param {Array<Object>} data - Array of objects to export
 * @param {string} filename - Name of the file to download
 * @param {Array<string>} [headers] - Optional array of header names to include (and their order)
 * @returns {void}
 */
export const exportToExcel = (data, filename, headers = null) => {
  if (!data || !data.length) {
    console.warn('No data to export');
    return;
  }

  try {
    // If headers not provided, use all keys from the first object
    const headerFields = headers || Object.keys(data[0]);
    
    // Map data to only include specified headers in the right order
    const mappedData = data.map(item => {
      const row = {};
      headerFields.forEach(header => {
        row[header] = item[header] !== undefined ? item[header] : '';
      });
      return row;
    });

    // Convert to CSV
    const csv = Papa.unparse(mappedData, {
      header: true,
      skipEmptyLines: true
    });

    // Create Blob with correct MIME type for Excel compatibility
    const blob = new Blob([csv], { 
      type: 'text/csv;charset=utf-8;' 
    });

    // Create download link
    const link = document.createElement('a');
    
    // Create object URL
    const url = URL.createObjectURL(blob);
    
    // Set link properties
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    
    // Add to DOM, trigger click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up object URL
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 100);
    
    return true;
  } catch (error) {
    console.error('Error exporting data:', error);
    return false;
  }
};

/**
 * Format date as YYYY-MM-DD
 * 
 * @param {Date} [date] - Date to format (defaults to current date)
 * @returns {string} Formatted date string
 */
export const formatDateForFilename = (date = new Date()) => {
  return date.toISOString().split('T')[0];
};
